var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSearch = function SvgIconSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #008060;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3782",
    "data-name": "Group 3782",
    transform: "translate(-736 -749.66)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    className: "cls-1",
    width: 24,
    height: 24,
    transform: "translate(736 749.66)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9421",
    "data-name": "Group 9421",
    transform: "translate(739.5 753.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9421-2",
    "data-name": "Group 9421",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4731",
    "data-name": "Path 4731",
    className: "cls-2",
    d: "M45.444,175.033h3.508a.251.251,0,0,0,0-.5H45.444a.251.251,0,1,0,0,.5Z",
    transform: "translate(-43.681 -168.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4733",
    "data-name": "Path 4733",
    className: "cls-2",
    d: "M45.444,274.392h3.419a.251.251,0,1,0,0-.5H45.444a.251.251,0,1,0,0,.5Z",
    transform: "translate(-43.681 -264.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4734",
    "data-name": "Path 4734",
    className: "cls-2",
    d: "M45.444,312.64h3.789a.251.251,0,0,0,0-.5H45.444a.251.251,0,0,0,0,.5Z",
    transform: "translate(-43.681 -301.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4736",
    "data-name": "Path 4736",
    className: "cls-2",
    d: "M45.444,389.134H53a.251.251,0,0,0,0-.5H45.444a.251.251,0,0,0,0,.5Z",
    transform: "translate(-43.681 -375.784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4737",
    "data-name": "Path 4737",
    className: "cls-2",
    d: "M45.444,427.382H53a.251.251,0,0,0,0-.5H45.444a.251.251,0,0,0,0,.5Z",
    transform: "translate(-43.681 -412.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4738",
    "data-name": "Path 4738",
    className: "cls-2",
    d: "M17.111,17.718a1.116,1.116,0,0,0-.439-.74L12.72,14.019a3.535,3.535,0,0,0-.7-3.7V7.582a.84.84,0,0,0-.839-.839H8.791v-.3a.451.451,0,0,0-.45-.45H7.5a1.488,1.488,0,0,0-2.975,0H3.684a.451.451,0,0,0-.45.45v.3H.839A.84.84,0,0,0,0,7.582V18.02a.251.251,0,0,0,.5,0V7.582a.338.338,0,0,1,.338-.338H3.234v.3a.451.451,0,0,0,.45.45H8.341a.451.451,0,0,0,.45-.45v-.3h2.394a.338.338,0,0,1,.338.338V9.869a3.539,3.539,0,0,0-4.955,4.937.251.251,0,0,0,.405-.3,3.036,3.036,0,1,1,.785.748.251.251,0,1,0-.276.419,3.537,3.537,0,0,0,3.788.063l.253.189v4.577a.338.338,0,0,1-.338.338H.839A.338.338,0,0,1,.5,20.506V19.191a.251.251,0,1,0-.5,0v1.315a.84.84,0,0,0,.839.839H11.185a.84.84,0,0,0,.839-.839v-4.2l3.3,2.472A1.115,1.115,0,0,0,16,19a1.139,1.139,0,0,0,.162-.012,1.123,1.123,0,0,0,.952-1.272ZM8.289,7.5H3.735v-1h.931a.36.36,0,0,0,.359-.359V6.014A.986.986,0,1,1,7,6.014v.118a.36.36,0,0,0,.359.359h.931v1ZM11.7,15.433a3.565,3.565,0,0,0,.8-.954l.585.438-.745,1Zm4.8,2.817a.622.622,0,0,1-.87.125l-2.887-2.162.745-1,2.887,2.162a.623.623,0,0,1,.125.87Z",
    transform: "translate(0 -4.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4739",
    "data-name": "Path 4739",
    className: "cls-2",
    d: "M213.979,183.974a2.349,2.349,0,1,0-2.349-2.349A2.351,2.351,0,0,0,213.979,183.974Zm0-4.2a1.847,1.847,0,1,1-1.847,1.847A1.849,1.849,0,0,1,213.979,179.779Z",
    transform: "translate(-204.551 -173.432)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-search.966b369b.svg";
export { ForwardRef as ReactComponent };